"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterHelpCenterLink = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("@waglabs/link"));

var _span = _interopRequireDefault(require("@waglabs/span"));

var _HelpIcon = require("./HelpIcon");

var _urls = require("../../urls");

var _utils = require("../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultStyles = {
  alignItems: 'center',
  cursor: 'pointer'
};

var FooterHelpCenterLink = function FooterHelpCenterLink(props) {
  var style = props.style;

  var _helper$attachQuerySt = _utils.helper.attachQueryStringToRoute(_urls.helpCenterLinkData),
      helpCenterLinkUrl = _helper$attachQuerySt.url;

  return _react["default"].createElement(_link["default"], _extends({
    alignItems: "center",
    color: "#01BE8F",
    cursor: "pointer",
    display: "flex",
    href: helpCenterLinkUrl
  }, props, {
    style: _objectSpread({}, defaultStyles, {}, style)
  }), _react["default"].createElement(_span["default"], {
    display: "inline-flex",
    mr: "8px",
    style: {
      cursor: 'pointer'
    }
  }, _react["default"].createElement(_HelpIcon.HelpIcon, {
    color: "#01BE8F",
    fontSize: "1.25rem"
  })), _react["default"].createElement(_span["default"], {
    fontFamily: "body",
    fontSize: ['1rem', '1rem', '1.125rem'],
    style: {
      cursor: 'pointer'
    }
  }, "Help Center"));
};

exports.FooterHelpCenterLink = FooterHelpCenterLink;